import { render, staticRenderFns } from "./PostcodeDashboardItem.vue?vue&type=template&id=5926bbf0"
import script from "./PostcodeDashboardItem.vue?vue&type=script&lang=js"
export * from "./PostcodeDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5926bbf0')) {
      api.createRecord('5926bbf0', component.options)
    } else {
      api.reload('5926bbf0', component.options)
    }
    module.hot.accept("./PostcodeDashboardItem.vue?vue&type=template&id=5926bbf0", function () {
      api.rerender('5926bbf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/PostcodeDashboardItem.vue"
export default component.exports